/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * AddExportModal.tsx
 */

import React from "react";
import NavigationService, {NavigationListener} from "../../service/NavigationService";
import {Page} from "../../model/pagination/Page";
import HiloReactComponent from "./HiloReactComponent";

interface Props {
}

interface State {
}

export default class PageSelector extends HiloReactComponent<Props, State> implements NavigationListener {
    private readonly _navigationService : NavigationService;

    constructor(props: Props, state: State) {
        super(props, state);

        this._navigationService = this._serviceRepository.resolve(NavigationService.id) as NavigationService;
    }


    /**
     * componentDidMount
     */
    public componentDidMount() {
        super.componentDidMount();
        this._navigationService.addListener(this);
    }

    /**
     * componentWillUnmount
     */
    public componentWillUnmount() {
        super.componentWillUnmount();
        this._navigationService.removeListener(this);
    }

    private _page = (props: { page: Page }) => {
        return <div className={`page-item`} onClick={() => {
            this._navigationService.load(props.page.paths[0]);
        }}>
            <img src={props.page.icon} alt={"icon"}/>
            <p className={"not-selected"}>{props.page.titleAccessor(this.t)}</p>
        </div>
    }

    /**
     * historyHasBeenUpdated
     */
    historyHasBeenUpdated(): void {
        this.setState({
            currentPage: this._navigationService.currentPage
        })
    }

    /**
     * renderBody
     */
    public render(): JSX.Element {
        return <div className={"page-selector"}>
            {
                NavigationService.pages.map(page => <this._page key={page.paths[0]} page={page}/>)
            }
        </div>
    }
}